import AddButton from "components/Button/AddButton";
import BackButton from "components/Button/BackButton";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";

const BookingExperinceInfo = ({ experience }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const convertTimeToHoursAndMinutes = (time) => {
    if (!time || typeof time !== "string" || !time.includes(":")) {
      return "Invalid time format";
    }
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours} hour${hours > 1 ? "s" : ""} and ${minutes} minute${
      minutes > 1 ? "s" : ""
    }`;
  };
  return (
    <Container className="py-5 bg-white">
      <Row>
        <Col xs="12">
          <CardBody>
            <CardTitle tag="h1" className="text-center mb-4">
              Experience Details
            </CardTitle>

            <Row>
              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-3">
                      Experience Basics
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Activities:</strong>
                      </Col>
                      <Col xs="7">{experience?.coreActivities}</Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Goods and Services:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.goodsOrServices
                          ?.map((item, index) => item)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Intended Audience:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.intendedAudience
                          ?.map((item, index) => item?.name)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Group Size:</strong>
                      </Col>
                      <Col xs="7">{experience?.maxGroupSize}</Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-3">
                      Location Details
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Arrival Spot Location:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.arrivalLocation?.flatNo}{" "}
                        {experience?.arrivalLocation?.streetAddress},{" "}
                        {experience?.arrivalLocation?.city} ,{" "}
                        {experience?.arrivalLocation?.state} ,{" "}
                        {experience?.arrivalLocation?.country} ,{" "}
                        {experience?.arrivalLocation?.zipCode}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Experience Spot Location:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.location?.flatNo}{" "}
                        {experience?.location?.streetAddress} ,{" "}
                        {experience?.location?.city} ,{" "}
                        {experience?.location?.state} ,{" "}
                        {experience?.location?.country} ,{" "}
                        {experience?.location?.zipCode}{" "}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      className="m-0 mb-3 font-bold border-bottom text-center pb-2"
                    >
                      Duration and Price
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Duration:</strong>
                      </Col>
                      <Col xs="7">
                        {convertTimeToHoursAndMinutes(experience?.duration)}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Price per Person:</strong>
                      </Col>
                      <Col xs="7">Rs. {experience?.price}</Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      className="m-0 mb-3 font-bold border-bottom text-center pb-2"
                    >
                      Designed
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Intended Audience:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.intendedAudience
                          ?.map((item, index) => item?.name)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Group Size:</strong>
                      </Col>
                      <Col xs="7">{experience?.maxGroupSize}</Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Event type:</strong>
                      </Col>
                      <Col xs="7">{experience?.typeOfHosting || "Open event"}</Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-3">
                      Vibes
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Place Vibe:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.placeVibes
                          ?.map((item, index) => item?.name)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Activity Vibe:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.activityVibes
                          ?.map((item, index) => item?.name)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Buddy Vibe:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.buddyVibes
                          ?.map((item, index) => item?.name)
                          .join(", ")}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6" className="mb-4">
                <Card className="h-100 shadow">
                  <CardBody>
                    <CardTitle tag="h5" className="mb-3">
                      Experience Enhancements
                    </CardTitle>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Entry Elements:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.enhanceEntry
                          ?.map((item, index) => item)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Surprise Gifts:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.gifts
                          ?.map((item, index) => item)
                          .join(", ")}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>Exit Elements:</strong>
                      </Col>
                      <Col xs="7">
                        {experience?.enhanceExit
                          ?.map((item, index) => item)
                          .join(", ")}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            
            <Row>
              <Col md="6" className="mb-4">
                <Card className="h-[100%]] shadow">
                  <CardBody>
              
             
             
                    <Row className="mb-2">
                      <Col xs="5">
                        <strong>What will happen:</strong>
                      </Col>
                      <Col xs="7">
                      {experience?.description?.length > 50
                          ? experience?.description.slice(0, 50) + "..."
                          : experience?.description}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

            </Row>

            <div className="d-flex justify-content-between align-items-center">
              <BackButton onClick={() => navigate(-1)} />
            </div>
          </CardBody>
        </Col>
      </Row>
    </Container>
  );
};

export default BookingExperinceInfo;
